// Collection description fold (snippets/ec-description-fold.liquid).
// The 2-line clamp is pure CSS (only with JavaScript on); this script switches it open/closed and
// hides the toggle while the folded text already shows everything (checked again on resize).

class EcDescriptionFold extends HTMLElement {
  connectedCallback() {
    this.text = this.querySelector('.ec-fold__text')
    this.button = this.querySelector('.ec-fold__toggle')
    this.label = this.querySelector('[data-ec-fold-label]')
    if (!this.text || !this.button) return

    this.abortController = new AbortController()
    this.button.addEventListener('click', () => this.toggle(), { signal: this.abortController.signal })
    this.checkFits = this.checkFits.bind(this)
    this.resizeObserver = new ResizeObserver(this.checkFits)
    this.resizeObserver.observe(this.text)
    this.checkFits()
  }

  disconnectedCallback() {
    this.abortController?.abort()
    this.resizeObserver?.disconnect()
  }

  checkFits() {
    if (this.classList.contains('is-open')) return
    this.classList.toggle('is-fits', this.text.scrollHeight <= this.text.clientHeight + 1)
  }

  toggle() {
    const open = !this.classList.contains('is-open')
    this.classList.toggle('is-open', open)
    this.button.setAttribute('aria-expanded', String(open))
    this.label.textContent = open ? this.button.dataset.labelLess : this.button.dataset.labelMore
    // Closing a long text: bring the start of it back into view
    if (!open && this.getBoundingClientRect().top < 0) this.scrollIntoView({ block: 'start' })
  }
}

if (!customElements.get('ec-description-fold')) {
  customElements.define('ec-description-fold', EcDescriptionFold)
}
